import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="31c1hoavsjsfq">
      <MetaPixel data-id="element-1" data-mp="2wka18t6cn33b" />
      <CountdownBar data-id="element-2" data-mp="2wjqi594yq8np" />
      <main data-id="element-3" data-mp="2wj8dbo48im46">
        <Hero data-id="element-4" data-mp="2wifbn1k4umsw" />
        <StatsBar data-id="element-5" data-mp="2whxbhtucnofp" />
        <Difference data-id="element-6" data-mp="28ufoscpxzgjl" />
        <WhatsInside data-id="element-7" data-mp="28tw972nrl48q" />
        <InsidePages data-id="element-8" data-mp="28t4lsf4bmctj" />
        <Bonuses data-id="element-9" data-mp="28sl5t3y8dyi5" />
        <Offer data-id="element-10" data-mp="28s2z1ddy01vz" />
        <Guarantee data-id="element-11" data-mp="23vkuoemiy5k6" />
        <Testimonials data-id="element-12" data-mp="23w4ek0vqj40u" />
      </main>
      <Footer data-id="element-13" data-mp="23v2sz2h3ez4v" />
    </div>;
}